import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonitoring = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ç¼ç»",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path 206",
			d: "M1 1V13H13",
			stroke: "",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path 25",
			d: "M3.66667 10.3333L6.33333 5L9.66667 8L13 1",
			stroke: "",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgMonitoring;
